<div class="Customers overview-loyalty ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'common.promos' | translate }}</h1>
  </div>

  <div class="ui-g-12">

    <kv-search-toolbar
      [dateBoxEnabled]="true"
      [date_structure]="searchModel.date_structure"
      [card_modes]="searchModel.card_modes"
      [clusters]="searchModel.cluster_list"
      [customersBoxEnabled]="false"
      [clusterFieldEnabled]="false"
      [selectedElapsedStart]="searchModel.selectedStartDate"
      [selectedElapsedEnd]="searchModel.selectedEndDate"
      [group_types]="searchModel.group_types"
      [groups]="searchModel.groups"
      [areas]="searchModel.areas"
      [stores]="searchModel.stores"
      [disableMutualExclusivity]="false"
      appQFilter
      (onQFilter)="searchValueTrend($event)"
    ></kv-search-toolbar>

    <div class="ui-g">
      <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
        <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
      </div>
    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
      <h2>{{ translations.promoDistributionValue }}</h2>
      <div class="chart-container">
        <chart [options]="waterfallChart.options"
               (load)="setChartInstance(waterfallChart, $event.context)"></chart>
      </div>
    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
      <h2>{{ translations.investment }}</h2>
      <div class="chart-container">
        <chart [options]="investmentChart.options"
               (load)="setChartInstance(investmentChart, $event.context)"></chart>
      </div>
    </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
      <p>{{ selectOneError }}</p>
      <div class="ui-dialog-footer">
        <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
      </div>
    </p-dialog>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-promo/overview-promo.component.html